/**
 * External dependencies
 */

import { get, values } from 'lodash';


export const getAllDispatchPlans = (state) => values(get(state, ['dispatchPlans', 'items']));

export const requestingDispatchPlans = (state) => get(state, ['dispatchPlans', 'requesting']);

export const errorRequestingDispatchPlans = (state) => get(state, ['dispatchPlans', 'error']);